<template>
  <div class="my-pagination">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-model:current-page="innerPage"
      v-model:page-size="innerSize"
      :page-sizes="pageSizes"
      @current-change="onChange"
      @size-change="onChange"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  total: { type: Number, default: 0 },
  page: { type: Number, default: 1 },
  size: { type: Number, default: 20 },
  pageSizes: { type: Array, default: () => [10, 20, 50, 100] }
})

const emit = defineEmits(['update:page', 'update:size', 'change'])

const innerPage = ref(props.page)
const innerSize = ref(props.size)

watch(() => props.page, v => { if (v !== undefined && v !== innerPage.value) innerPage.value = v })
watch(() => props.size, v => { if (v !== undefined && v !== innerSize.value) innerSize.value = v })

function onChange() {
  emit('update:page', innerPage.value)
  emit('update:size', innerSize.value)
  emit('change', innerPage.value, innerSize.value)
}
</script>

<style scoped>
.my-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0 4px;
}
</style>
